// extracted by mini-css-extract-plugin
export default {"container":"EmptyChannelList__container___DtFdC"};